import styled from 'styled-components'

export const RejectTextMessage = styled.div`
  margin-top: 0.5rem;
`
